// Brand asset URLs — served from our own /public folder (same-origin).
// Local files avoid the 500+ KB proxied downloads on every page load and are
// CORS-safe for the JPG export feature (html-to-image canvas reads).
export const LOGO_URL = "/brand/logo.png";
export const LOGO_DARK_URL = "/brand/logo.png";
// High-resolution variant for A3/TV print exports
export const LOGO_PRINT_URL = "/brand/logo-print.png";
